/**
 * Кто вправе распоряжаться владельцем ящика.
 *
 * Одно место вместо двух литералов `role === 'owner' || role === 'admin'`,
 * разъехавшихся по карточке ящика и форме подключения. По критерию карты
 * знаний это были две независимые копии: появилась бы четвёртая роль —
 * один компонент показал бы поле, другой нет.
 *
 * На бэкенде тот же вопрос решает `mailboxZoneFor` из
 * `core/services/auth/types.ts` — исчерпывающей таблицей, чтобы новая
 * роль не собралась, пока решение по ней не принято явно.
 */

import type { UserRole } from '../types';

export function canManageMailboxOwner(role: UserRole | undefined): boolean {
  return role === 'owner' || role === 'admin';
}
